module.exports = __webpack_public_path__ + "img/pizza_goat_cheese.18434cf0.jpg";